module.exports = __webpack_public_path__ + "img/iphone-view.4f7271e9.svg";